module.exports = __webpack_public_path__ + "img/Frame 1070six.bd17e607.png";